import { Box, Flex, IconButton } from '@chakra-ui/react';
import { MdEdit } from 'react-icons/md';

import { booleanBodyRender, TableColumn } from '@app/components/common/table';
import { SubChannel } from '@app/api';

export const useColumns = ({
  channels,
  onEdit,
}: {
  channels: EntityBase[];
  onEdit: (route: EntityBase) => void;
}): TableColumn<SubChannel>[] => {
  return [
    {
      name: 'id',
      label: '#',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'channel',
      label: 'Канал',
      options: {
        filter: {
          name: 'channel',
          type: 'select',
          onApply: (value: EntityBase) => value.name,
          onOptionsFetch: () => channels,
        },
        sort: true,
        customBodyRender: (value) => {
          return (
            <Box whiteSpace="pre-wrap" style={{ wordBreak: 'break-all' }}>
              {value.toString()}
            </Box>
          );
        },
      },
    },
    {
      name: 'sub_channel',
      label: 'Подканал',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => {
          return (
            <Box whiteSpace="pre-wrap" style={{ wordBreak: 'break-all' }}>
              {value.toString()}
            </Box>
          );
        },
      },
    },
    {
      name: 'is_active',
      label: 'Активен',
      options: {
        filter: {
          type: 'boolean',
        },
        sort: true,
        customBodyRender: booleanBodyRender(),
      },
    },
    {
      name: 'id',
      label: 'Действия',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (id, { rowData }) => {
          return (
            <Flex gap={2}>
              <IconButton name="edit" onClick={() => onEdit(rowData)} aria-label="edit">
                <MdEdit />
              </IconButton>
            </Flex>
          );
        },
      },
    },
  ];
};
